import { CLIENT_ID } from "Constants";

const initialState = {
  tenantId: "",
  applicationId: CLIENT_ID,
  userId: "",
  userName: "",
  rawUser: {},
  rejected: false
};

export const UPDATE_SESSION_STORAGE = "user/update";

export default (state = initialState, action) => {
  let { type, ...data } = action;
  void type;
  switch (action.type) {
    case UPDATE_SESSION_STORAGE:
      return {
        ...state,
        ...data
      };
    default:
      return state;
  }
};
